/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const GET_INV_QTR_NOT_PAID_DISPLAY_OBJ =
  'GET_INV_QTR_NOT_PAID_DISPLAY_OBJ';
export const GET_INV_QTR_NOT_PAID_DETAIL_OBJ =
  'GET_INV_QTR_NOT_PAID_DETAIL_OBJ';
export const GET_PLAN_TYPE_DATA = 'GET_PLAN_TYPE_DATA';
export const REFRESH_INVOICE_QTR_NOT_PAID_DISPLAY =
  'REFRESH_INVOICE_QTR_NOT_PAID_DISPLAY';
export const GET_ERROR_MSG_INV_QTR_NOT_PAID = 'GET_ERROR_MSG_INV_QTR_NOT_PAID';
export const GET_INVOICE_QTR_NOT_PAID_DATA = 'GET_INVOICE_QTR_NOT_PAID_DATA';
export const DISPLAY_INV_QTR_NOT_PAID_INPUT_FIELD =
  'DISPLAY_INV_QTR_NOT_PAID_INPUT_FIELD';
export const GET_REBATE_QUARTER_VALUE = 'GET_REBATE_QUARTER_VALUE';
export const IS_LOADING = 'IS_LOADING';
export const GET_INVOICE_DETAILS_BY_INVOICE_NUM =
  'GET_INVOICE_DETAILS_BY_INVOICE_NUM';
export const REFRESH_INVOICE_QTR_NOT_PAID = 'REFRESH_INVOICE_QTR_NOT_PAID';
export const SET_INVOICE_FOR_QTR_NOT_PAID_EXTRA_STATE = 'SET_INVOICE_FOR_QTR_NOT_PAID_EXTRA_STATE';
export const RESET_INVOICE_QTR_NOT_PAID="RESET_INVOICE_QTR_NOT_PAID";